import { connect } from 'react-redux';
import Action from '../state/Action';
import Select from '../state/Select';

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    set: Select.windows.getSetByKey(state, ownProps.setKey),
    windows: Select.windows.getWindowsBySetKeyAsObject(state, ownProps.setKey)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    onWindowClick: function onWindowClick(windowKey) {
      dispatch(Action.windows.topWindow(ownProps.setKey, windowKey));
    },
    onWindowClose: function onWindowClose(windowKey) {
      dispatch(Action.windows.remove(ownProps.setKey, windowKey));
    },
    onWindowDragStart: function onWindowDragStart(windowKey) {
      dispatch(Action.windows.topWindow(ownProps.setKey, windowKey));
    },
    onWindowDragStop: function onWindowDragStop(windowKey, position) {
      dispatch(Action.windows.updateSettings(windowKey, {
        position: position
      }));
    },
    onWindowResize: function onWindowResize(windowKey, width, height, position) {
      dispatch(Action.windows.updateSettings(windowKey, {
        width: width,
        height: height,
        position: position
      }));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps);